import type { PaymentOption } from '@src/domains/payments/types/payment';

const UPFRONT_DIVISION = 1;

export const resolveMaxInterestFreeInstallments = (paymentOption: PaymentOption | undefined): number | null => {
  const installmentOptions = paymentOption?.installmentOptions;

  if (!installmentOptions?.length) {
    return null;
  }

  const upfront = installmentOptions.find((option) => option.division === UPFRONT_DIVISION);

  if (!upfront?.amountCurrencyInfo) {
    return null;
  }

  const upfrontTotalCents = upfront.amountCurrencyInfo.amountCents;

  const maxInterestFree = installmentOptions.reduce((largest, option) => {
    const isInterestFree = option.amountCurrencyInfo?.amountCents === upfrontTotalCents;

    return isInterestFree && option.division > largest ? option.division : largest;
  }, 0);

  return maxInterestFree > UPFRONT_DIVISION ? maxInterestFree : null;
};
